<template>
  <div id="my-account-tokens">
    <div class="alert -danger" v-if="errors.cantFetchTokensList">
      <p>Ocorreu um erro desconhecido ao tentar obter os tokens de sua conta, por favor tente novamente.</p>
    </div>

    <div class="form-group" v-for="(token, key) in tokens">
      <label :for="`${token.label}-${key}`" class="label">{{ token.label }}</label>
      <div class="form-copy-content" v-copy-content>
        <input type="text" :for="`${token.label}-${key}`" class="form-control" :data-value="token.token" :value="token.token.substr(0,8).padEnd(92, '*')" disabled>
      </div>
    </div>

    <loader v-if="loading"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';
import copyContent from '@/support/directives/copyContent';

export default {
  name: 'Tokens',

  data() {
    return {
      loading: false,
      errors: {
        cantFetchTokensList: false,
      },
    };
  },

  methods: {
    /**
     * Fetch the tokens list.
     *
     * @returns {Promise<void>}
     */
    async fetchTokensList() {
      try {
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/fetchTokensList');
      } catch {
        this.errors.cantFetchTokensList = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors from page.
     */
    resetErrors() {
      this.errors.cantFetchTokensList = false;
    },
  },

  computed: {
    ...mapState('auth', {
      tokens: 'tokens',
    }),
  },

  mounted() {
    this.fetchTokensList();
  },

  directives: {
    copyContent,
  },

  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>
#my-account-tokens {
}
</style>
